var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.19 57.16",
    style: {
      enableBackground: "new 0 0 51.19 57.16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000072970810805020784690000015373174625464141983_);}\n\t.st3{clip-path:url(#SVGID_00000110441889906202369570000012687435006858828719_);}\n\t.st4{clip-path:url(#SVGID_00000002378545582561914490000004030740802604791471_);fill:#55BBB1;}\n\t.st5{clip-path:url(#SVGID_00000128483125442350680050000004132040572277639594_);}\n\t.st6{clip-path:url(#SVGID_00000010296945811652571070000009496152055803763841_);fill:#55BBB1;}\n\t.st7{clip-path:url(#SVGID_00000124856534853074150810000010156237766406443421_);}\n\t.st8{clip-path:url(#SVGID_00000029004265619700989310000012710710078235812280_);fill:#55BBB1;}\n\t.st9{clip-path:url(#SVGID_00000079472421246615786720000008133370190676130231_);}\n\t.st10{clip-path:url(#SVGID_00000126319340234146994670000012288940081914933134_);fill:#55BBB1;}\n\t.st11{clip-path:url(#SVGID_00000079457209932716953160000006435681049436694442_);}\n\t.st12{clip-path:url(#SVGID_00000109031905805140231810000012755712277557582255_);fill:#55BBB1;}\n\t.st13{clip-path:url(#SVGID_00000173867616602346928060000015051110133117016255_);}\n\t.st14{clip-path:url(#SVGID_00000097478752502751170200000005043692595606267048_);fill:#55BBB1;}\n\t.st15{clip-path:url(#SVGID_00000093164667769031710070000016886676619276537781_);}\n\t.st16{clip-path:url(#SVGID_00000134209174034705169390000015793288282459763368_);fill:#55BBB1;}\n\t.st17{clip-path:url(#SVGID_00000148654755223239510130000010740624238131185290_);}\n\t.st18{clip-path:url(#SVGID_00000124873383262006070430000002833607969674322057_);fill:#55BBB1;}\n\t.st19{clip-path:url(#SVGID_00000070797939396902615070000001866442668445047486_);}\n\t.st20{clip-path:url(#SVGID_00000163052696323387248630000013371920672029740441_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 66,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAA9CAYAAAD24tTCAAAACXBIWXMAAAsSAAALEgHS3X78AAAF HElEQVR4nO1bW3LbMAyEFedM/eidepjeqR89Ux2rHx060GoXD1H19BHMaEhJJACu8CLjmH3QBzG6 zEz+8v1baf7XT5/XGTnPktUGo6qUoo6yz5Rl1gRjVrlBFSWfKWtQWWBBOfZeKhIpmchqyclkebpW BgXUBeihVOPLV8b5MYdjxgwYF9GvzKko3HWTwfNS5L+jo2AwIDrKnxIPHK22BeEQIGe5iWp/J62u vdgekDaVlAb/9gvO+i05CeEiV9sCovpmVguiZ7kJu8w4MDhfEVs8tiuMe6qbKBAW06DMuFAEAF53 Mq8FyhHLwIUuSVuxFEXM/MfCsV1sC4hZ0zpSxUi8YCCoC8caaRkxixgLH3114dhy3OhYBjN/v/AX aBkoaCkRKVfw1xvhdSfPShYSKiWswluEB+CF3C+Wuw1S5hYDhDfo+3tmIWYWW4cEI3EPtIgrAILg MECqYCgg8LoBGN5tSoBQMERdgTHCL/gqWnQbjB+oA6ZJBsRob6L1VuLnb/gzQKoxw39JtAoPyLiU dTBXYaTixGLvcQJ5sKLL3Pg0buwUKrgHLvRqZq+2BcMD4q3D86LyndKYPTBG3IJLWUjoLpFlVLKH X7gCA93kKBhoFWyeukrZZTMosQrlEq+2tw6MG5GbRKau0qmPEzcz+wEtWggLqGa2tQ5lGVn2YK7C 2iy9Vr4w6pONj6xDBesQjEGRiyjXYEB0ii+2CCyzcTybN1wLeclAOnzXu0gUK5irZPUFWkYEDAO+ Y50qkyk5m9DwAENQVHYzpY6W3hVSoKnKt53SqzFDWUi0OYsyRUSqXkDdvAsMne6kj+MHj1bMiNyG geXHssX5+zEO0x4DYlcfBDqyYM22APSjIBi4GAUICvCLYQEMlWFp1fPwvLCPBRTy8nVMtBca/TS1 InMWA7JMMBRnvFAG8shaln7xa6OcSG8zO34GytIYmjv7YqhYRYaJ1hdkUSxSlr6bo7KJ8vusMlS7 SbywUqy+V7tTtQ/xuksa6VVZxkr6EQirvUfwyJ1SUw3ksz7T5xAgZrGbMMEo/A3eq/oCF98Bg90r naJ9iMpID7qahX8EZgIvtj17HHk+O8WqWoWXzfr4jH0geewXUSWAMjAu9st3GRAsQGYZhMmM7vG5 X7yPHy1AMjdhWQPfV7bmRp5lFWq3WsUjwrarMDB8WsTU6VuDMbNADF7RvSKvJ+uXeGXZBGsHtI4x BsHAuVU3mQHDTLtGVoesZnswvFX4Z5G7ZNmjGziHTPWsUsKzCjWlLIAOcBhz7z4ICLoaLiJzkyhg VuZWANhVoUfKcQ8QLjhStsJX3XdjB/YVbQBhu9YO+a/uQYqEyi20xQAovv59yy2QZn/GhKTcA59X dqvYj2QoXi06C4woRqDFVCwjsgrkxcYwXlNFV0TIGL++Eh4BgXMqQZSNZymVAbVzqS4YWYBU6Y9Z B5tXASoDNOIZzqvWGSxAVpViYzvWkcUHzztqUxesWgbLFEppJnCmxmD3TFal8GpZhlKAWcHduMX4 ORG/TLmKJbA5CAoeIMsUvJilP/xSjLwgdtLEfhbAfobUeccOcNQ5hvwpgqLKrpW5R7ZDRZrdl1T4 ZfEidZvsPEMBod5HdORQ5ygxIJD/TlYUM6J4oFKkom46rPCL5kaLlzI2TMlZ6JEziZIsQWeBwZ5J qxgxs7KFH8JnTfgsF+jwytL0Jnks6gVhgsj+DZfSn5I03bP+e/BPJfbhSwv+V4A545+N/xv6CV02 ioh6mNBvAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -6.9927 -1.4194)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6.99,
    y: -1.42,
    className: "st0",
    width: 66,
    height: 60
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3.01,
    y: 8.58,
    width: 46,
    height: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127022346893257833340000013426378792505547917_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089549060700106058320000017326603195037297323_",
    d: "M6.15,40.83c-1.55,0-3.14,1.23-3.14,3.39 c0,1.97,1.4,3.36,3.14,3.36c1.44,0,2.08-0.96,2.08-0.96v0.42c0,0.2,0.19,0.42,0.42,0.42h1.04v-6.48H8.22v0.82 C8.22,41.8,7.58,40.83,6.15,40.83L6.15,40.83z M6.41,42.16c1.27,0,1.94,1.11,1.94,2.06c0,1.06-0.79,2.06-1.94,2.06 c-0.96,0-1.92-0.77-1.92-2.07C4.49,43.03,5.32,42.16,6.41,42.16z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054259694535260605940000014729833998723957914_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089549060700106058320000017326603195037297323_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054259694535260605940000014729833998723957914_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026162083940073121530000011253952206271289750_",
    x: 3.01,
    y: 40.83,
    width: 6.67,
    height: 6.75
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075144159964713354020000014384457345378860989_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026162083940073121530000011253952206271289750_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.01,
    y: 39.83,
    style: {
      clipPath: "url(#SVGID_00000075144159964713354020000014384457345378860989_)",
      fill: "#55BBB1"
    },
    width: 8.67,
    height: 8.75
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072967494158200081550000003161357995970919824_",
    d: "M11.71,47.46c-0.22,0-0.42-0.16-0.42-0.42v-6.06h1.46 v0.8c0.33-0.49,0.98-0.95,1.97-0.95c1.62,0,2.48,1.28,2.48,2.48v4.15h-1.01c-0.27,0-0.44-0.22-0.44-0.44v-3.39 c0-0.66-0.41-1.47-1.36-1.47c-1.02,0-1.63,0.96-1.63,1.86v3.44H11.71z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158000393679748823420000004727989987813618361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072967494158200081550000003161357995970919824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158000393679748823420000004727989987813618361_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172431193201895958520000005359020985455193789_",
    x: -6.99,
    y: -1.42,
    width: 65,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132804714624227727580000002985269232061853361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172431193201895958520000005359020985455193789_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.29,
    y: 39.83,
    style: {
      clipPath: "url(#SVGID_00000132804714624227727580000002985269232061853361_)",
      fill: "#55BBB1"
    },
    width: 7.91,
    height: 8.63
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052815653347677475890000001196749094735657107_",
    d: "M21.44,40.83c-1.55,0-3.14,1.23-3.14,3.39 c0,1.97,1.4,3.36,3.14,3.36c1.44,0,2.08-0.96,2.08-0.96v0.42c0,0.2,0.19,0.42,0.42,0.42h1.04v-9.72h-1.46v4.06 C23.52,41.8,22.87,40.83,21.44,40.83L21.44,40.83z M21.7,42.16c1.27,0,1.94,1.11,1.94,2.06c0,1.06-0.79,2.06-1.94,2.06 c-0.96,0-1.92-0.77-1.92-2.07C19.79,43.03,20.61,42.16,21.7,42.16z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119824464396635299660000001976238367411733139_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052815653347677475890000001196749094735657107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119824464396635299660000001976238367411733139_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145047336212907942030000008772464079543460502_",
    x: -6.99,
    y: -1.42,
    width: 65,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180329790824493606490000005134175510235789213_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145047336212907942030000008772464079543460502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 36.74,
    style: {
      clipPath: "url(#SVGID_00000180329790824493606490000005134175510235789213_)",
      fill: "#55BBB1"
    },
    width: 8.67,
    height: 11.84
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000092447747573541076810000007074866392142799255_",
    d: "M27,47.46c-0.22,0-0.42-0.16-0.42-0.42v-6.06h1.46 v1.08c0.25-0.6,0.79-1.15,1.75-1.15c0.27,0,0.52,0.05,0.52,0.05v1.5c0,0-0.31-0.12-0.69-0.12c-1.02,0-1.58,0.96-1.58,1.86v3.26 H27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029029739166016260990000003884031345082477954_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092447747573541076810000007074866392142799255_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029029739166016260990000003884031345082477954_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000064335596952899574030000012907316601181364153_",
    x: -6.99,
    y: -1.42,
    width: 65,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114065614635466450530000012659189189671043994_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064335596952899574030000012907316601181364153_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.58,
    y: 39.91,
    style: {
      clipPath: "url(#SVGID_00000114065614635466450530000012659189189671043994_)",
      fill: "#55BBB1"
    },
    width: 5.73,
    height: 8.55
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080900994561011713160000012235042920833431180_",
    d: "M39.16,47.46c-0.22,0-0.42-0.16-0.42-0.42v-6.06h1.46 v6.48H39.16z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088094936937055162400000013270440915326660271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080900994561011713160000012235042920833431180_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088094936937055162400000013270440915326660271_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068668003880422279250000000410885604487932041_",
    x: -6.99,
    y: -1.42,
    width: 65,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043444329417218402170000005558573318178569643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068668003880422279250000000410885604487932041_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.74,
    y: 39.98,
    style: {
      clipPath: "url(#SVGID_00000043444329417218402170000005558573318178569643_)",
      fill: "#55BBB1"
    },
    width: 3.46,
    height: 8.48
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114768328667817749730000009634216193379646383_",
    d: "M44.47,40.83c-1.55,0-3.14,1.23-3.14,3.39 c0,1.97,1.4,3.36,3.14,3.36c1.44,0,2.08-0.96,2.08-0.96v0.42c0,0.2,0.19,0.42,0.42,0.42h1.04v-9.72h-1.46v4.06 C46.55,41.8,45.9,40.83,44.47,40.83L44.47,40.83z M44.73,42.16c1.27,0,1.94,1.11,1.94,2.06c0,1.06-0.79,2.06-1.94,2.06 c-0.96,0-1.92-0.77-1.92-2.07C42.82,43.03,43.64,42.16,44.73,42.16z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046300159405479462640000015161911492917442703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114768328667817749730000009634216193379646383_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046300159405479462640000015161911492917442703_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000042709427845350503790000001377101981424801171_",
    x: 41.34,
    y: 37.74,
    width: 6.67,
    height: 9.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080893514092238121240000007594465798110943405_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042709427845350503790000001377101981424801171_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.34,
    y: 36.74,
    style: {
      clipPath: "url(#SVGID_00000080893514092238121240000007594465798110943405_)",
      fill: "#55BBB1"
    },
    width: 8.67,
    height: 11.84
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000066491038934417040700000006932224694085717411_",
    d: "M39.46,37.67c0.53,0,0.96,0.43,0.96,0.96 s-0.43,0.96-0.96,0.96s-0.96-0.43-0.96-0.96S38.93,37.67,39.46,37.67"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062170340749922334240000016198967074536122791_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066491038934417040700000006932224694085717411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062170340749922334240000016198967074536122791_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179605054444442644020000000823533122218038407_",
    x: -6.99,
    y: -1.42,
    width: 65,
    height: 59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182506897437808600080000004608183891282296212_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179605054444442644020000000823533122218038407_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 36.67,
    style: {
      clipPath: "url(#SVGID_00000182506897437808600080000004608183891282296212_)",
      fill: "#55BBB1"
    },
    width: 3.93,
    height: 3.91
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139293237895766480790000012693939120259422381_",
    d: "M34.16,40.83c-1.62,0-3.4,1.2-3.4,3.38 c0,1.98,1.52,3.37,3.4,3.37c2.32,0,3.45-1.85,3.45-3.36C37.61,42.37,36.15,40.83,34.16,40.83z M34.16,42.18 c1.12,0,1.96,0.9,1.96,2.03c0,1.15-0.89,2.04-1.95,2.04c-0.99,0-1.95-0.8-1.95-2.02C32.22,42.99,33.13,42.18,34.16,42.18z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088105923208210069780000001203395559177914022_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139293237895766480790000012693939120259422381_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088105923208210069780000001203395559177914022_)"
    }
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044884401317319626200000010409455168852413109_",
    x: 30.76,
    y: 40.83,
    width: 6.85,
    height: 6.75
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058585412293827030680000013302920334446806183_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044884401317319626200000010409455168852413109_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.76,
    y: 39.83,
    style: {
      clipPath: "url(#SVGID_00000058585412293827030680000013302920334446806183_)",
      fill: "#55BBB1"
    },
    width: 8.85,
    height: 8.75
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127022346893257833340000013426378792505547917_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044153541474839698330000000039126267717130671_",
    d: "M36.49,16.12l3.73-6.42c0.21-0.36,0.08-0.82-0.27-1.03 c-0.36-0.21-0.82-0.09-1.03,0.27l-3.78,6.5c-2.88-1.31-6.13-2.04-9.62-2.04c-3.49,0-6.74,0.73-9.62,2.04l-3.78-6.5 c-0.21-0.36-0.67-0.48-1.03-0.27c-0.36,0.21-0.48,0.67-0.27,1.03l3.73,6.42C8.11,19.59,3.75,26.05,3.03,33.62H48 C47.28,26.05,42.93,19.59,36.49,16.12L36.49,16.12z M15.19,27.35c-1.04,0-1.88-0.84-1.88-1.87c0-1.04,0.85-1.87,1.88-1.87 c1.04,0,1.88,0.84,1.88,1.87C17.08,26.51,16.24,27.35,15.19,27.35z M35.84,27.35c-1.04,0-1.88-0.84-1.88-1.87 c0-1.04,0.85-1.87,1.88-1.87c1.04,0,1.88,0.84,1.88,1.87C37.73,26.51,36.88,27.35,35.84,27.35z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013905807102238382830000017021569954090341547_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044153541474839698330000000039126267717130671_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013905807102238382830000017021569954090341547_)"
    }
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120554768047190651270000018221663503317246856_",
    x: 3.03,
    y: 8.58,
    width: 44.97,
    height: 25.04
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121961824099148348210000000048879884183737779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120554768047190651270000018221663503317246856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.03,
    y: 7.58,
    style: {
      clipPath: "url(#SVGID_00000121961824099148348210000000048879884183737779_)",
      fill: "#55BBB1"
    },
    width: 46.97,
    height: 27.04
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.a14bc0a05f2843a37a7dc783581d7a88.svg";
export { ForwardRef as ReactComponent };